import { inject, Injectable, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { UrlsEnum } from '@lentau/ui-kit/core/enums/route.enum';
import { FeatureToggleService } from '@lentau/core/feature-toggle';

@Injectable({ providedIn: 'root' })
export class BdGuardService {
  private router: Router = inject(Router);
  private isTestHideBdCoupon: Signal<boolean> = inject(FeatureToggleService).isHideDeliveryBdPromocode();

  public canActivate(): boolean {
    this.router.navigate([UrlsEnum.Coupons], this.isTestHideBdCoupon() ? {} : { queryParams: { birthday: true } });
    return true;
  }
}
